import { ReactNode } from 'react';
import classNames from 'classnames';
import Link from '@/components/Link';

import styles from './submenu-block.module.css';

interface SubmenuBlockProps {
  href?: string,
  className?: string,
  title: ReactNode,
  children: ReactNode,
  onClick?: () => void,
}

const SubmenuBlock = ({ href, className, title, children, onClick }: SubmenuBlockProps) => {
  if (href) return (
    <Link className={classNames(styles.root, className)} href={href} onClick={onClick}>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>{children}</div>
    </Link>
  );

  return (
    <div className={classNames(styles.root, className)} onClick={onClick}>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default SubmenuBlock;
